import { Text } from '@wix/design-system';
import React from 'react';
import { BiCtaNames, BiModalTypes } from '../../bi/types';
import { isClassicEditorHost } from '../../utils/get-editor-host';
import { buildStudioDialogProps } from './build-studio-dialog-props';
export const getStopGeneratingModalProps = (t, editorHost) => ({
  content: isClassicEditorHost(editorHost) ? t('accessibility-wizard.alt-text.stop-generating-modal.content') : /*#__PURE__*/React.createElement(Text, null, t('accessibility-wizard.alt-text.stop-generating-modal.content')),
  primaryButtonText: t('accessibility-wizard.alt-text.stop-generating-modal.primary-button'),
  secondaryButtonText: t('accessibility-wizard.alt-text.stop-generating-modal.secondary-button'),
  theme: 'standard',
  title: t('accessibility-wizard.alt-text.stop-generating-modal.title')
});
export const showStopGeneratingSuggestionsModal = async _ref => {
  let {
    biLogger,
    handleApply,
    a11yWizardAdapter,
    t,
    handleDiscard,
    editorHost
  } = _ref;
  const modalProps = {
    ...getStopGeneratingModalProps(t, editorHost),
    primaryButtonOnClick: () => {
      biLogger.modalCtaClick({
        ctaName: BiCtaNames.ContinueGenerating,
        modalType: BiModalTypes.GenerateWithAi
      });
      handleApply();
    },
    secondaryButtonOnClick: () => {
      biLogger.modalCtaClick({
        ctaName: BiCtaNames.StopGenerating,
        modalType: BiModalTypes.GenerateWithAi
      });
      handleDiscard();
    }
  };
  biLogger.modalView({
    modalType: BiModalTypes.GenerateWithAi
  });
  if (isClassicEditorHost(editorHost)) {
    await a11yWizardAdapter.showDialog(modalProps);
    return;
  }
  await a11yWizardAdapter.showDialog(...buildStudioDialogProps(modalProps));
};
//# sourceMappingURL=show-stop-generating-suggestions-modal.js.map